import { MsalProvider } from "@azure/msal-react";
import { FluentProvider, webLightTheme } from "@fluentui/react-components";
import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";

import App from "./App";
import msal from "./common/msal";
import store from "./store/store";
import { useGlobalFluentOverrides } from "./styles/globalFluentOverrides";

import "./styles/styles.css";

/* ---- Fluent Tokens (TRUE GLOBALS) ---- */
const theme = {
  ...webLightTheme,

  /* Borders / Radius */
  borderRadiusSmall: "2px",

  /* Neutral */
  colorNeutralStroke1: "#605e5c",
  colorNeutralBackgroundDisabled: "#f3f2f1",
  colorNeutralForegroundDisabled: "#a19f9d",

  /* Brand */
  colorBrandStroke1: "#0078d4",
};

const AppWrapper = () => {
  const styles = useGlobalFluentOverrides();

  return (
    <FluentProvider theme={theme} targetDocument={typeof window !== "undefined" ? window.document : undefined}>
      <div className={styles.root}>
        <App />
      </div>
    </FluentProvider>
  );
};

const container = document.getElementById("app")!;
const root = createRoot(container);

// msal-browser v3 requires async initialization before any MSAL API calls.
// We must await initialize() before rendering MsalProvider.
msal
  .initialize()
  .then(() => {
    root.render(
      <React.StrictMode>
        <MsalProvider instance={msal}>
          <Provider store={store}>
            <AppWrapper />
          </Provider>
        </MsalProvider>
      </React.StrictMode>,
    );
  })
  .catch((err) => {
    console.error("MSAL initialization failed:", err);
    root.render(
      <React.StrictMode>
        <div style={{ padding: "2rem", textAlign: "center" }}>
          <h1>Authentication Error</h1>
          <p>Failed to initialize authentication. Please refresh the page or try again later.</p>
        </div>
      </React.StrictMode>,
    );
  });
